module.exports = __webpack_public_path__ + "static/media/searchClose.a8cd6f4b.svg";